type Props = {
  className?: string;
};

export default function RemarkIcon({ className }: Props) {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.2507 1H2.25C2.05109 1 1.86032 1.07902 1.71967 1.21967C1.57902 1.36032 1.5 1.55109 1.5 1.75V18.25C1.5 18.4489 1.57902 18.6397 1.71967 18.7803C1.86032 18.921 2.05109 19 2.25 19H15.7507C15.8492 19 15.9468 18.9806 16.0377 18.9429C16.1287 18.9052 16.2114 18.85 16.2811 18.7803C16.3507 18.7107 16.406 18.628 16.4436 18.537C16.4813 18.446 16.5007 18.3485 16.5007 18.25V6.25M11.2507 1L16.5007 6.25M11.2507 1V6.25H16.5007M6.00073 13.75H12.0007M6.00073 10.75H12.0007"
        stroke="#4A72FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
